import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const ITIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="IT" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M11.2 0H16v12h-4.8V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#5EAA22"
        fillRule="evenodd"
        d="M0 0h4.8v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#fff"
        fillRule="evenodd"
        d="M4.8 0h6.4v12H4.8V0Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
